const workList = [
  {
    img: 'iiw.png',
    altImg: 'Ikhwanulis Ikhlas | Home Page',
    name: 'PT. Ikhwanul Ikhlas Wisata',
    stack: 'jQuery • Boostrap • PHP • Mysql',
    what: 'Designed and Developed',
    githubLink: '',
    websiteLink: 'https://www.ikhwanulikhlaswisata.com',
    detailLink: 'iiw',
    detailTextColor: '',
    id: 'iiw'
  },
  {
    img: 'sisda.png',
    altImg: 'SISDA',
    name: 'Eportal Sisda Provinsi Sumatera Utara',
    stack: 'jQuery • Boostrap • PHP • Codeingiter • Mysql',
    what: 'Designed and Developed',
    githubLink: '',
    websiteLink: 'http://sisda.sumutprov.go.id/',
    detailLink: 'sisda',
    detailTextColor: '',
    id: 'sisda'
  },
  {
    img: 'doding.png',
    altImg: 'Doding Haleluya',
    name: 'Doding Haleluya',
    stack: 'Java • Android Studio • SQLite ',
    what: 'Designed and Developed',
    githubLink: '',
    websiteLink:
      'https://play.google.com/store/apps/details?id=com.tua.bona.dodinghaleluya',
    detailLink: 'doding',
    detailTextColor: 'gray29',
    id: 'doding'
  },
  {
    img: 'bpr.png',
    altImg: 'BPR Intidana',
    name: 'BPR Intidana',
    stack: 'Wordpress',
    what: 'Designed and Developed',
    githubLink: '',
    websiteLink: 'http://bprintidana.co.id/',
    detailLink: 'bpr',
    detailTextColor: 'gray29',
    id: 'bpr'
  }
];

export default workList;



// WEBPACK FOOTER //
// ./src/components/data/workList.js